import { render } from "./phone-reg.vue?vue&type=template&id=65a515ab&scoped=true"
import script from "./phone-reg.vue?vue&type=script&lang=js"
export * from "./phone-reg.vue?vue&type=script&lang=js"

import "./phone-reg.vue?vue&type=style&index=0&id=65a515ab&lang=less&scoped=true"

import exportComponent from "/root/project/msp-fronted/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65a515ab"]])

export default __exports__